<template>
  <div>
    <b-container class="black explorer">
      <h3 class="interactive-title">Geänderte Meilensteine</h3>

      <b-row>
        <div class="col-sm-12 col-md-12 col-lg-12">
          <ul
            class="list-group list-group-flush scrolling-list"
            v-if="ozgTimelineItemChanges"
          >
            <li
              class="list-group-item"
              v-for="event in ozgTimelineItemChanges"
              v-bind:key="event.id"
            >
              {{ event.current.service.name }}
              <OZGLevelEmoji
                :level="event.current.service.implementationLevel"
              />
              <br />
              <b
                >{{ moment(event.current.start).format("DD.MM.YYYY") }} -
                {{ event.current.status.event }}
                <OZGLevelEmoji
                  v-if="event.previous"
                  :previousDate="event.previous.start"
                  :dateChangeType="event.editType"
                />
                <OZGLevelEmoji
                  v-else
                  :dateChangeType="event.editType"
                ></OZGLevelEmoji>
              </b>
            </li>
          </ul>
        </div> </b-row
    ></b-container>
  </div>
</template>

<script>
import OZGLevelEmoji from "./../OZGLevelEmoji";

export default {
  name: "WeeklyMilestones",
  props: ["start", "end"],
  data() {
    return {
      ozgTimelineItemChanges: []
    };
  },
  components: { OZGLevelEmoji },

  apollo: {
    $client: "ozgClient",

    ozgTimelineItemChanges: {
      query() {
        return require("../../graphql/weeklyChangedMilestones.gql");
      },
      variables: function() {
        return {
          start: this.$props.start,
          end: this.$props.end
        };
      }
    }
  }
};
</script>

<style scoped></style>

<style scoped lang="scss">
.scrolling-list {
  max-height: 600px;
  overflow-y: scroll;
  padding-bottom: 30px;
}

.scrolling-list::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

.scrolling-list::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background-color: #111111;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.9);
}

.vbt-autcomplete-list {
  border-radius: 0px;

  .list-group-item:first-child {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
  .list-group-item:last-child {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
}
.interactive-title {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
  font-style: italic;
}

.black {
  border: #111111 solid 2px !important;
}

.list-group-flush > .list-group-item {
  padding-left: 0;
}
</style>
